import React from 'react'
import AppRoutes from './routes'

export default props => {
  return (
    <AppRoutes />
  )
}
